import { NAVIGATION } from 'constants/store.constants';

export const selectNavigationSlice = (state) => state[NAVIGATION];
export const selectNavLocked = (state) => selectNavigationSlice(state).navLocked;
export const selectBlockMessage = (state) => selectNavigationSlice(state).message;
